import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useRoomLoadingState } from "./useRoomLoadingState";
import { LoadingScreenFluent } from "./LoadingScreenFluent";

export function LoadingScreenContainer({ onLoaded, scene, backgroundColor = null, destination = null }) {
  const { loading, message, objectCount, loadedCount, environmentLoaded, donePreloading, allObjectsLoaded } =
    useRoomLoadingState(scene);

  useEffect(() => {
    if (!loading) {
      onLoaded();
    }
  }, [loading, onLoaded]);

  return (
    <LoadingScreenFluent
      backgroundColor={backgroundColor}
      message={message}
      objectCount={objectCount}
      loadedCount={loadedCount}
      environmentLoaded={environmentLoaded}
      donePreloading={donePreloading}
      allObjectsLoaded={allObjectsLoaded}
      destination={destination}
    />
  );
}

LoadingScreenContainer.propTypes = {
  scene: PropTypes.object.isRequired,
  onLoaded: PropTypes.func.isRequired,
  backgroundColor: PropTypes.string,
  destination: PropTypes.string
};
